export default __webpack_public_path__ + "static/media/manila.a398a58e.png";